module.exports = __webpack_public_path__ + "media/pages/assets/images/region-f90e2e84fba0635ce6d7bf6e18de3536.svg";